const JS_DAY_TO_WEEKDAY = [
  "SUNDAY",
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];

const WEEKDAY_LABELS_AR = {
  SUNDAY: "الأحد",
  MONDAY: "الإثنين",
  TUESDAY: "الثلاثاء",
  WEDNESDAY: "الأربعاء",
  THURSDAY: "الخميس",
  FRIDAY: "الجمعة",
  SATURDAY: "السبت",
};

export const LEAVE_ON_WEEKLY_REST_MESSAGE =
  "لا يمكن تقديم إجازة في يوم الراحة الأسبوعية";

export function normalizeWeeklyRestDay(value) {
  if (!value) return "FRIDAY";
  const upper = String(value).toUpperCase();
  return JS_DAY_TO_WEEKDAY.includes(upper) ? upper : "FRIDAY";
}

export function weeklyRestDayLabelAr(value) {
  return WEEKDAY_LABELS_AR[normalizeWeeklyRestDay(value)] || "الجمعة";
}

/** Parse YYYY-MM-DD as UTC date-only. */
export function parseDateOnlyIso(value) {
  if (!value) return null;
  const iso = String(value).slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!match) return null;
  return new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])));
}

export function addUtcDays(date, days) {
  const next = new Date(date.getTime());
  next.setUTCDate(next.getUTCDate() + days);
  return next;
}

export function isFixedWeeklyRestDate(date, weeklyRestDay) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return false;
  const rest = normalizeWeeklyRestDay(weeklyRestDay);
  return JS_DAY_TO_WEEKDAY[date.getUTCDay()] === rest;
}

/**
 * Find first weekly-rest day covered by a leave request.
 * @returns {{ dateIso: string, label: string } | null}
 */
export function findWeeklyRestConflictInLeaveRange({
  startDate,
  days = 1,
  weeklyRestDay,
}) {
  const start = parseDateOnlyIso(startDate);
  if (!start) return null;
  const leaveDays = Number(days);
  const span =
    Number.isFinite(leaveDays) && leaveDays > 0
      ? leaveDays >= 1
        ? Math.floor(leaveDays)
        : 1
      : 1;
  const rest = normalizeWeeklyRestDay(weeklyRestDay);

  for (let offset = 0; offset < span; offset += 1) {
    const date = addUtcDays(start, offset);
    if (isFixedWeeklyRestDate(date, rest)) {
      const dateIso = date.toISOString().slice(0, 10);
      return {
        dateIso,
        label: weeklyRestDayLabelAr(rest),
      };
    }
  }
  return null;
}

export function weeklyRestConflictMessage(conflict) {
  if (!conflict?.dateIso) return LEAVE_ON_WEEKLY_REST_MESSAGE;
  return `${LEAVE_ON_WEEKLY_REST_MESSAGE} (${conflict.dateIso})`;
}
